import {
    Component,
    inject,
    signal,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/userService';

@Component({
    selector: 'app-error-handling',
    imports: [MatCardModule, MatDivider, MatButtonModule, MatIcon, MatTooltip],
    templateUrl: './error-handling.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './error-handling.component.scss',
})
export class ErrorHandlingComponent {
    userService = inject(UserService);
    router = inject(Router);
    lastError = signal<string>('');
    deniedUrl = sessionStorage.getItem('deniedUrl');

    ngOnInit() {
        this.lastError.set(
            sessionStorage.getItem('lastError') ?? 'No Error Found',
        );
    }
    updateUser() {
        this.userService.updateAccessRights();
    }
}
